
import { useUnifiedDashboardData } from './useUnifiedDashboardData';
import type { DashboardStats, UniqueFilterValues } from './useUnifiedDashboardData';

export type { DashboardStats, UniqueFilterValues };

export const useRentalDashboardData = () => {
  return useUnifiedDashboardData('aluguel');
};
